import Cache from 'root/cache';

export function loadSurveys(on_success) {
    Cache.app.request({
        action: 'survey/search',
        success: (response) => {
            if (on_success) {
                on_success(response);
            }
        }
    });
}